import { render, staticRenderFns } from "./Sample0109.vue?vue&type=template&id=4e88e2a9&scoped=true&lang=pug&"
import script from "./Sample0109.vue?vue&type=script&lang=js&"
export * from "./Sample0109.vue?vue&type=script&lang=js&"
import style0 from "./Sample0109.vue?vue&type=style&index=0&id=4e88e2a9&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e88e2a9",
  null
  
)

export default component.exports